import React from "react";

interface Text {
   style?: "regular" | "serif";
   children?: React.ReactNode;
};

const H1: React.FC<Text> = ({ style = "regular", children }) => (
   <h1 className={`${style}`}>{children}</h1>
);

const H2: React.FC<Text> = ({ style = "regular", children }) => (
   <h2 className={`${style}`}>{children}</h2>
);

const H3: React.FC<Text> = ({ style = "regular", children }) => (
   <h3 className={`${style}`}>{children}</h3>
);

const Body: React.FC<Text> = ({ style = "regular", children }) => (
   <p className={`body ${style}`}>{children}</p>
);

const Detail: React.FC<Text> = ({ style = "regular", children }) => (
   <p className={`detail ${style}`}>{children}</p>
)

export { H1, H2, H3, Body, Detail };